import { KeyboardArrowDown } from '@mui/icons-material';
import { CircularProgress, IconButton, List, ListItem, Tooltip, Typography, listItemButtonClasses, listItemClasses } from '@mui/joy';
import { FC, useState } from 'react'
import { ISingleCategoryProps } from '../../types';
import CategoryLinkContainer from './CategoryLinkContainer';
import DeleteIcon from '@mui/icons-material/Delete';
import ShareIcon from '@mui/icons-material/Share';
import axios from 'axios';
import { BACKEND_URL, FRONTEND_URL } from '../../constants';
import { useSnackbarDispatch } from '../../SnackbarDataStore/Context';
import { setSnackbar } from '../../controllers/snackController';
import { useUserDataDispatchContext } from '../../LinkDataStore/Context';
import { deleteCategory } from '../../controllers/userDataController';

const SingleCategory: FC<ISingleCategoryProps> = ({ data, shared }) => {
	const { links, tagName } = data;
	const [open, setOpen] = useState(false);
	const [loadShare, setLoadShare] = useState(false);
	const snackDispatch = useSnackbarDispatch();
	const dataDispatch = useUserDataDispatchContext();

	async function handleShareCategory() {
		try {
			setLoadShare(true);
			const response = await axios.post(BACKEND_URL+"/data/createSharableLink", {categoryid: data._id});
			if (!response.data.error) {
				navigator.clipboard.writeText(FRONTEND_URL+"/share/"+response.data.shareId);
				setSnackbar(snackDispatch, "Copied to clipboard", "success");
				setLoadShare(false);
				return;
			}

			setSnackbar(snackDispatch, "Something went wrong", "error");
			setLoadShare(false);
			return;

		} catch(err) {
			setSnackbar(snackDispatch, "Something went wrong", "error");
			setLoadShare(false);
			return;
		}
	}

	async function handleDeleteCategory() {
		try {

			const resp = await deleteCategory(dataDispatch, data._id);

			if (resp) {
				setSnackbar(snackDispatch, "Category Deleted", "success");
				return;
			}

			setSnackbar(snackDispatch, "Something went wrong", "error");
			return;

		} catch(err) {
			setSnackbar(snackDispatch, "Something went wrong", "error");
			return;
		}
	}

	return (
		<List
			sx={()=>({
				'--List-insetStart': '32px',
				'--List-item-paddingY': '0px',
				'--List-item-paddingRight': '16px',
				'--List-item-paddingLeft': '30px',
				'--List-item-startActionWidth': '0px',
				'--List-item-startActionTranslateX': '-50%',

				[`& .${listItemButtonClasses.root}`]: {
					borderLeft: '1px solid',
					borderColor: 'divider',
				},
				[`& .${listItemButtonClasses.root}.${listItemButtonClasses.selected}`]:
					{
					borderColor: 'currentColor',
					},
				[`& .${listItemClasses.nested} > .${listItemButtonClasses.root}`]: {
					border: 'none',
				},
				'& [class*="startAction"]': {
					color: 'var(--joy-palette-text-tertiary)',
				},
		})}
		>
			<ListItem
				startAction={
					<IconButton
						variant="plain"
						size="sm"
						color="neutral"
						sx={{
							backgroundColor: "white",
							zIndex: 1
						}}
						onClick={() => setOpen(!open)}
					>
						<KeyboardArrowDown
							sx={{ transform: open ? "initial" : "rotate(-90deg)" }}
						/>
					</IconButton>
				}
				sx={{
					position: "sticky",
					top: "0",
					backgroundColor: "white",
					zIndex: 1,
					display: "flex",
					justifyContent: "space-between",
					flexDirection: "row"

				}}
			>
				<Typography
					level='inherit'
					sx={{
						fontWeight: open ? "bold" : undefined,
						color: open ? "text.primary" : "inherit",
					}}
				>
					{tagName}
				</Typography>
				{!(tagName==="general")&&!shared&&<div>
					<Tooltip variant='outlined' arrow color='primary' title="Create sharable link">
						<IconButton disabled={loadShare} onClick={handleShareCategory} sx={{padding: "0 10px", margin: "0 10px"}} variant='plain' color='neutral' size='sm'>
							{loadShare?<CircularProgress/>:<ShareIcon/>}
						</IconButton>
					</Tooltip>
					{<Tooltip variant='outlined' arrow color='primary' title="Delete category">
						<IconButton onClick={handleDeleteCategory} sx={{padding: "0 10px", margin: "0 10px"}} variant='plain' color='neutral' size='sm'>
							<DeleteIcon/>
						</IconButton>
					</Tooltip>}
				</div>}
			</ListItem>
			{open &&
				<List
					sx={{
						'--List-item-paddingLeft': '30px',
					}}
				>
					{links.map((elem) => {
						return (
							<>
								<ListItem className="p-0" key={elem._id}>
									<CategoryLinkContainer shared={shared} data={elem} categoryId={data._id}/>
								</ListItem>
							</>
						)
					})}
				</List>
			}
		</List>
	)
}

export default SingleCategory;